import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, unref as _unref } from "vue";
import { ElConfigProvider } from "element-plus";
import ru from "element-plus/lib/locale/lang/ru";
import MainMenu from "@/components/MainMenu.vue";
import { onMounted, ref } from "vue";
import useDictionary from "@/composables/useDictionary";
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      getDictionary
    } = useDictionary();
    const locale = ref(ru);
    onMounted(() => getDictionary());
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: locale.value
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component,
            route
          }) => [route.name ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [route.name && !(route.name === 'login') ? (_openBlock(), _createBlock(MainMenu, {
            key: 0
          })) : _createCommentVNode("", true), _createVNode(_Transition, {
            name: route.meta.transitionName || 'fade',
            mode: "out-in"
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            }))]),
            _: 2
          }, 1032, ["name"])], 64)) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }

});